/* eslint-disable react/no-unknown-property */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LayoutProvider from '../../../../../Contexts/LayoutProvider';
import ReloadButton from '../../../../../features/ReloadButton/ReloadButton';
import { ButtonPest } from '../../../../../utils/Button';
import { InputFieldSearch } from '../../../../../utils/InputField';
import { PrintIcon } from '../../../../../utils/SVGIcon';
import { mkRelativeUrl } from '../../../../../utils/URL';
import cn from '../../../../../utils/cn';

function PageHeaderLeftCol({ handleReload }) {
    const [formData, setFormData] = useState({});

    const navigate = useNavigate();

    const handleOnchange = (event) => {
        const { name, value } = event.target;

        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleFilterDataSearch = (event) => {
        event.preventDefault();
        navigate(mkRelativeUrl(`/billing/invoices/${formData?.q}/info`));
        handleReload();
    };

    return (
        <form onSubmit={handleFilterDataSearch} className="h-full">
            <div className="search_box w-full sm:w-[300px] h-8 md:h-10">
                <InputFieldSearch
                    placeholder="Search Invoice Ex: 0009293 -1203-12"
                    name="q"
                    onChange={handleOnchange}
                    formData={formData}
                />
            </div>
        </form>
    );
}

function PageHeaderRightCol({ handleReload, invoiceInfo, isReceipt }) {
    return (
        <div className="flex items-center gap-3">
            {!isReceipt ? <ReloadButton height="h-10" width="w-10" onClick={handleReload} /> : null}

            <LayoutProvider>
                <ButtonPest
                    btnType="submit"
                    title="Print"
                    disabled={invoiceInfo && Object.keys(invoiceInfo).length === 0}
                    onClick={() => window.print()}
                    layout="lg"
                />
                <button
                    type="button"
                    disabled={invoiceInfo && Object.keys(invoiceInfo).length === 0}
                    onClick={() => window.print()}
                    className="w-[40px] disabled:grayscale disabled:cursor-default disabled:select-none focus:outline-none"
                    layout={['md', 'sm', 'xs', 'xxs']}
                >
                    <PrintIcon />
                </button>
            </LayoutProvider>
        </div>
    );
}

function PageHeader({ handleReload, invoiceInfo, isReceipt }) {
    return (
        <div className="flex justify-center">
            <div
                className={cn(
                    `customer_page_header w-full mb-3 md:mb-7 flex flex-row justify-between items-center gap-5 print:hidden`,
                    {
                        'justify-end': isReceipt
                    }
                )}
            >
                {!isReceipt ? <PageHeaderLeftCol handleReload={handleReload} /> : null}
                <PageHeaderRightCol
                    handleReload={handleReload}
                    invoiceInfo={invoiceInfo}
                    isReceipt={isReceipt}
                />
            </div>
        </div>
    );
}

export default PageHeader;
